export default {
  "": "If the loan exceeds the repayment period, your borrowed asset will incur three (3) times the interest during the overdue period. In case of a delay exceeding {'{'}{hour}{'}'} hours, your collateral assets will be liquidated to repay the borrowed amount and interest.",
  "action": "操作",
  "AddLoan": "增加",
  "AdjustLoanFail": "质押资产调整失败，请重试。",
  "all": "全部",
  "applicationRecords": "申请记录",
  "apply": "申请",
  "appResultThen": "申请结果。",
  "approvalInProgress": "审核中",
  "assets": "资产",
  "available": "可用",
  "availableAssetsNewTips": "可用资产：<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">划转</a>或<a href=\"javascript:;\" class={depositClass} id=\"deposit\">充值</a>",
  "balance": "可用余额",
  "BorrowableAmountNewTips": "可借额度：{amount} {coin} 到",
  "borrowAmountNotZero": "借币数量不可为 0。  ",
  "borrowingAccount": "借款账户",
  "borrowingLimit": "申请借币上限",
  "botValidateErrCode101": "最小价格太低",
  "botValidateErrCode102": "最小价格太高",
  "botValidateErrCode103": "最大价格太低",
  "botValidateErrCode104": "最大价格太高",
  "botValidateErrCode105": "网格数太少",
  "botValidateErrCode106": "网格数太多",
  "botValidateErrCode107": "投资额太低，未满足投资要求。",
  "botValidateErrCode108": "投资额太高，大于合约投资上限。",
  "botValidateErrCode109": "止盈价太低",
  "botValidateErrCode110": "止盈价太高",
  "botValidateErrCode111": "止损价太低",
  "botValidateErrCode112": "止损价太高",
  "botValidateErrCode113": "入场价太低",
  "botValidateErrCode114": "入场价太高",
  "cancel": "取消",
  "cancelAll": "撤销全部",
  "cancelOrder": "撤单",
  "chooseVipCryptoLoans": "选择 VIP 质押借币，享受更高借币上限。现货或衍生品交易量越高，您可获得的借币上限也会越高。  ",
  "close": "关闭",
  "coin": "币种",
  "collateralAccount": "抵押账户",
  "confirm": "确认",
  "contactOnline": "联系客服",
  "contract_account": "合约账户",
  "createErrorCode400": "用户发送的数据包含非法参数。有关更多信息，请查看错误消息和错误详情。",
  "createErrorCode401": "余额不足。",
  "createErrorCode402": "用户创建的机器人数量已达上限。",
  "createErrorCode403": "服务禁用",
  "createErrorCode404": "所请求资源未找到。",
  "createErrorCode407": "该用户类型不支持创建机器人子账户。",
  "createErrorCode408": "选择了重复定投标的",
  "createErrorCode409": "最大投资额无效",
  "createErrorCode410": "最大投资额无效",
  "createErrorCode411": "机器人已被关闭",
  "createErrorCode412": "统一保证金账户升级中",
  "createErrorCode500": "服务器内部错误",
  "createErrorCode501": "内部处理超时",
  "createErrorCode503": "当前定投机器人无法关闭，可能正在进行定投买入。",
  "createTimes": "时间",
  "currency": "币种",
  "currentOperationFailed": "当前操作失败，请重试",
  "dailyRate": "日利率",
  "dedAccManager": "专属客户经理",
  "deposit": "充值",
  "detail": "详情",
  "direction": "方向",
  "earnSummary": "概述",
  "end": "结束时间",
  "enjoyPersonalizedVipLoan": "选择 VIP 质押借币，享受专属客户经理服务，以及贴合需求的定制化借款额度和期限。",
  "enterQuantity": "请输入数量",
  "EstimatedDailyInterest": "预估每日利息",
  "exceedLimitError": "超出平台借币和抵押上限",
  "exceedPlatformBorrowLimit": "超出平台借币上限",
  "exceedPlatformLimit": "超出平台抵押上限",
  "expiryDate": "失效日期",
  "failed": "失败",
  "FAQNewTips": "只要您是 Bybit 注册用户且资金账户或统一交易账户下有质押资产，即可进行借款。",
  "fiat": "法币",
  "filter": "筛选",
  "firstPage": "首页",
  "fixedRateLoan": "存贷易",
  "fixedRateTerm": "固定利率/期限",
  "from": "开始时间",
  "fullRepaymentAssetReturn": "全额还款后,质押资产将转回",
  "funding": "资金账户",
  "getHightLoanAmount": "解锁更高额度",
  "global_setting_quick_order_desc": "<p>1. 市价单（快捷下单）</p>\n<p>2. 请注意，填写的购买数量可能与输入的订单数量略有不同。</p>",
  "global_setting_quick_order_label": "快捷下单",
  "global_setting_title": "自定义设置（适用于现货）",
  "gotIt": "知道了",
  "hint": "提示",
  "hourlyAnnualIntRate": "小时利率/年利率",
  "HourlyAnnualizedInterestRate": "小时利率/年利率",
  "hoursAmountTips": "最低小时利息为 {amount} {coin}。请注意，系统按小时计息，不足 1 小时按 1 小时计算。",
  "idAuth": "立即认证",
  "iKnow": "我知道了",
  "innovateQuota": "可用额度",
  "inProgress": "进行中",
  "InsufficientAvailableAssetsTips": "可用资产不足，账户余额为 {num} {token}，请进行<a href=\"javascript:;\" class={transferClass} id=\"transfer\">划转</a>或<a href=\"javascript:;\" class={depositClass} id=\"Deposit\">充值</a>。",
  "insufficientLendingPoolDemand": "借贷需求旺盛，平台资金池额度不足，还请耐心等待。",
  "interestRatesHourlyYearly": "小时利率/年利率",
  "introUTAUMA": "统一交易账户",
  "kline": "K线",
  "lastSixMonthsCommissionRecords": "仅展示最近6个月内的订单记录",
  "lendingAnnouncements": "Bybit 余币宝与活期储蓄全面整合",
  "leverage": "杠杆倍数",
  "leverage_off_trade_tip": "请开启杠杆，然后参与杠杆交易。",
  "leverageCloseErrInfo": "操作失败！您需要还清全部欠款后，才能关闭杠杆交易。",
  "leverageCloseTips": "操作失败！您的账户存在进行中的杠杆订单。",
  "leverageLoanTips": "操作失败！您的统一保证金账户的 IM 或 MM 占用率已超过预警值。",
  "leverageTryAgain": "系统异常，请您稍后重试！",
  "limitGreaterNoNeedRequest": "您当前的借币上限大于本次申请的数量，您无需申请。",
  "liquidate": "已强制平仓",
  "liquidationErrorInfo": "操作失败！账户已触发强制平仓。",
  "LiquidationPrice": "强平价格",
  "loan": "借款",
  "loan_accont_assets_tip": "账户余额不足",
  "loan_account_tip": "抱歉，您的账户存在异常，暂时无法使用质押借币服务，如有疑问，请联系在线客服",
  "loan_agreement": "我已同意<a href={url} target=\"_blank\" class={className}>《借币条款协议》</a>",
  "loan_all_order": "所有订单",
  "loan_amount": "可借额度",
  "loan_amount_less_tip": "由于借贷需求过多，平台剩余可借额度不足，请降低借贷金额或明天再试。",
  "loan_amount_pledge_less_tip": "由于借贷需求过多，平台剩余可质押额度不足，请降低质押金额或明天再试。",
  "loan_apply": "提交借款申请",
  "loan_apply_time": "借款时间",
  "loan_assets_debt": "资产负债",
  "loan_assets_transfer": "将借入的资产划转至：",
  "loan_assets_transfer_layer": "借入的资产将划转至{account}",
  "loan_assets_transfer_tip": "借入的资产将自动划转至相应账户",
  "loan_available_funding_tip": "可用资金账户资产：<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">划转</a>或<a href=\"javascript:;\" class={depositClass} id=\"deposit\">充值</a>",
  "loan_available_funding_tip_new": "资金账户可用资产：<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">划转</a>或<a href=\"javascript:;\" class={depositClass} id=\"deposit\">充值</a>",
  "loan_available_spot_assets": "可用现货资产",
  "loan_available_spot_less": "可用现货资产不足，账户余额为 {num} {token}，请进行<a href=\"javascript:;\" class={transferClass} id=\"transfer\">划转</a>或<a href=\"javascript:;\" class={depositClass} id=\"Deposit\">充值</a>。",
  "loan_available_spot_tip": "可用现货资产：<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">划转</a>或<a href=\"javascript:;\" class={depositClass} id=\"deposit\">充值</a>",
  "loan_available_spot_tip_new": "现货账户可用资产：<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">划转</a>或<a href=\"javascript:;\" class={depositClass} id=\"deposit\">充值</a>",
  "loan_back_assets": "回款质押资产",
  "loan_borrow_tips": "*借入的资产将划转至资金账户。",
  "loan_confirm_amount": "借款金额",
  "loan_confirm_order": "确认订单",
  "loan_confirm_tips": "*借入的资产将划转至资金账户。",
  "loan_cope_interest": "应还利息",
  "loan_cope_principal": "应还本金",
  "loan_cope_total": "应还总额",
  "loan_covering_position_tip": "补仓中，无法还款",
  "loan_currency": "借款币种",
  "loan_debt_assets": "负债资产",
  "loan_debt_total": "总负债金额",
  "loan_edit_pledge_amount": "调整质押金",
  "loan_exceed_pledge_rate_tip": "暂无法借贷，该借贷后将超出追加保证金率",
  "loan_failed": "借款失败",
  "loan_high_exchange_rate": "高质押率 (LTV)",
  "loan_high_risk": "高风险",
  "loan_hour_day_rate": "小时利率/日利率",
  "loan_hour_day_rate_tip": "最低小时利息为 {precision} {token}。<br />\n\n日利率：{dayRate}<br />\n年利率：{yearRate}<br />\n\n注意：系统按小时计息，不足 1 小时按 1 小时计算。",
  "loan_init_ltv": "初始质押率",
  "loan_init_ltv_tip": "初始 LTV 决定了最初可借入的资产金额，因质押资产而异。",
  "loan_init_ltv_title": "初始质押率 (LTV)",
  "loan_input_amount": "请输入借款金额",
  "loan_input_pledge_amount": "请输入质押金额",
  "loan_instant_credit": "即时到账",
  "loan_interest_accruing": "计息中",
  "loan_interest_accruing_tip": "计息中，无法还款",
  "loan_interest_rate": "利率",
  "loan_interest_time": "计息时间",
  "loan_interest_time_unit": "{num}小时",
  "loan_kyc_tip": "请先完成基础身份认证，再使用质押借币服务",
  "loan_limit": "借款期限",
  "loan_limit_day": "{num}天",
  "loan_limit_tip": "利息以实际借款每小时计算利息，可提前还款，逾期后每小时将收取{multiple}倍小时利息，逾期超过{time}小时，您的抵押资产将被清算以偿还贷款和利息。",
  "loan_limit_tip_new": "如未能按时还款，逾期期间小时利息将按正常利率的 {num} 倍计算。逾期超过 {hour} 小时后，系统将对您的质押资产进行强平以偿还借款本息。",
  "loan_liquidate_ltv": "强平质押率",
  "loan_liquidate_ltv_tip": "如果 LTV（待还本息/质押金额）达到此阈值，系统会对您的质押资产进行强制平仓，以全额偿还本金和利息。",
  "loan_liquidate_pledge_tip": "强平中，无法调整质押金",
  "loan_liquidate_tip": "强平中，无法还款",
  "loan_liquidation": "强平中",
  "loan_liquidation_price": "强平价格",
  "loan_login": "登录后借款",
  "loan_login_tip": "请先 <a href={loginUrl} class={loginClass}>登录</a> 或 <a href={registerUrl} class={registerClass}>注册</a>，再使用质押借币服务。",
  "loan_low_risk": "低风险",
  "loan_lt_user_tip": "注意：借币成功后，机构借贷 LTV 可能会受到影响。",
  "loan_manual": "手工借款",
  "loan_max_amount": "最高金额：{num} {token}",
  "loan_max_amount_tip": "暂无法借贷，借贷额度已达上限",
  "loan_max_amount_tip2": "您当前 {coin} 的借贷金额已超过用户的最大借贷额度 {num} {coin}，请降低借贷金额或进行还款。",
  "loan_max_pledge_tip": "暂无法借贷，质押额度已达到上限",
  "loan_max_pledge_tip2": "您当前 {coin} 的质押金额已超过单用户的最大质押额度 {num} {coin}，请降低质押金额。",
  "loan_middle_risk": "中风险",
  "loan_min_amount": "最低金额：{num} {token}",
  "loan_min_amount_tip": "暂无法借贷，借贷额度低于下限",
  "loan_min_pledge_amount_tip": "暂无法借贷，质押额度低于下限",
  "loan_min_pledge_tip": "最小调整数量为：{num} {token}",
  "loan_no_order_tip": "您当前还没有借款订单。立即使用<span>质押借币</span>服务。",
  "loan_no_pledge_tip": "您当前还没有借款订单。立即使用<span>质押借币</span>服务。",
  "loan_now": "立即开始借币",
  "loan_order": "借还订单",
  "loan_order_number": "借款单号",
  "loan_over_capital": "剩余本金",
  "loan_over_interest": "剩余利息",
  "loan_overdue": "逾期中",
  "loan_paid_off": "已还清",
  "loan_pledge": "质押借币",
  "loan_pledge_amount": "质押金额",
  "loan_pledge_assets": "质押资产",
  "loan_pledge_deposit": "质押金",
  "loan_pledge_desc": "质押借币是指质押一种数字资产借入另外一种数字货币，用于交易现货、衍生品或投入理财以获取更高收益，也可用于提币。",
  "loan_pledge_failed": "调整质押率失败",
  "loan_pledge_processing": "调整质押率处理中",
  "loan_pledge_rate_after": "调整后质押率",
  "loan_pledge_rate_current": "当前质押率",
  "loan_pledge_rate_success": "调整质押率成功",
  "loan_pledge_rate_success_tip": "您成功追加质押金 {num} {token}，调整后质押率为：{rate}",
  "loan_pledge_rate_success_tip1": "质押资产成功减少 {num} {token}，调整后的质押率为 {ltv}",
  "loan_pledge_rate_tip": "质押率 (LTV) 是指借入资产价值与质押资产价值的比率。<br />\n\n初始 LTV：<span class=\"init\">{ltv1}%</span><br />\n初始 LTV 是指最初可借入的资产价值与质押资产价值的比率。<br />\n\n预警 LTV：<span class=\"warning\">{ltv2}%</span><br />\n如果 LTV（待还本息/质押金额）达到此阈值，系统会提醒您追加质押资产。<br />\n\n强平 LTV：<span class=\"liquidate\">{ltv3}%</span><br />\n如果 LTV（待还本息/质押金额）达到此阈值，系统会对您的质押资产进行强制平仓，以全额偿还本金和利息。",
  "loan_pledge_total": "总质押金额",
  "loan_pledge_total_amount": "质押总额",
  "loan_process": "借款流程",
  "loan_processing": "借款处理中",
  "loan_progress_order": "进行中订单",
  "loan_progress_order_qty": "进行中订单（{num}）",
  "loan_question1_title": "质押借币需要满足什么要求？",
  "loan_question2_detail": "系统按小时计息，根据实际借款时长收取，不足 1 小时按 1 小时计算。\n\n注意：利息根据借款时显示的利率计算得出。\n\n公式：利息 = 借款金额 × 小时利率",
  "loan_question2_title": "利息如何计算？",
  "loan_question3_detail": "Bybit 支持在到期日之前随时还款，不收取罚金。完成还款后，系统将根据实际借款时长收取利息。",
  "loan_question3_detail2": "只要您是 Bybit 的注册用戶且现货账户或资金账户中有质押资产，即可进行借款。",
  "loan_question3_title": "能否提前全额或部分还款？",
  "loan_question4_detail": "质押率 (LTV) 是指借入资产价值与质押资产价值的比率。\n\n具体计算公式如下：\n\n质押率 = 待还本息/质押金额\n\n待还本息 = (待还本金 + 待还利息 + 待还逾期利息)",
  "loan_question4_title": "质押率是什么？",
  "loan_question5_content": "您可以在订单页面调整质押金。您可以随时添加更多质押金。",
  "loan_question5_title": "如何调整质押金？",
  "loan_question6_content": "质押借币可用于包括加密货币收益率套利在内的各种高级策略，让您可以在一个平台以较低利率借入加密货币，然后在另一平台以较高利率借出。\n\n<a href={url} target=\"_blank\">点击此处了解详情</a>。",
  "loan_question6_title": "质押借币能否用于套利策略？",
  "loan_question7_content": "借入的资产可用于理财产品投资和 DeFi 收益耕作，还可用于杠杆交易，助您增加保证金，避免杠杆仓位遭到强平。\n\n<a href={url} target=\"_blank\">点击此处了解详情</a>。",
  "loan_question7_title": "如何使用质押借币服务？",
  "loan_received": "收到借款",
  "loan_repay_account_tip": "全额还款后，质押资产将转回现货账户。",
  "loan_repay_anytime": "随时还款",
  "loan_repay_failed": "还款失败",
  "loan_repay_interest": "还款付息",
  "loan_repay_min_amount": "最小还款数量：{num} {token}",
  "loan_repay_more_tip": "请不要超额还款",
  "loan_repay_processing": "还款处理中",
  "loan_repay_success": "还款成功",
  "loan_repay_success_tip": "您成功还款{num} {token}",
  "loan_repay_time": "应还款时间",
  "loan_repay_time_new": "应还时间",
  "loan_repay_tips": "*全额还款后，质押资产将转回资金账户。",
  "loan_spot_account": "现货账户",
  "loan_spot_assets_not_enough": "可用现货资产不足，请进行<a href=\"javascript:;\" class={transferClass} id=\"transfer\">划转</a>或<a href=\"javascript:;\" class={depositClass} id=\"deposit\">充值</a>。",
  "loan_submember_tip": "子账户不支持质押借币服务",
  "loan_success": "借款成功",
  "loan_success_tip": "您成功借款{num} {token}",
  "loan_total_amount": "借款总额",
  "loan_total_interest": "总利息",
  "loan_total_interest_new": "预估总利息",
  "loan_total_repay": "总还款",
  "loan_total_repayment": "还款总额",
  "loan_total_repayment_new": "预估总还款",
  "loan_type": "借款类型",
  "loan_user_manual": "用户手册",
  "loan_uta_tip1": "您已经升级为统一交易账户，现货账户功能已迁移至资金账户，无法再使用现货账户进行质押借币。可通过资金账户进行质押借币时，我们将另行通知。",
  "loan_uta_tip2": "统一交易账户升级中，暂时无法进行质押借币。",
  "loan_uta_tip3": "您已经升级为统一交易账户，现货账户功能已迁移至资金账户，无法再进行质押借币或调整质押金额。可通过资金账户进行质押借币时，我们将另行通知。",
  "loan_uta_tip4": "统一交易账户升级中，暂时无法调整质押金额。",
  "loan_uta_tip5": "统一交易账户升级中，暂时无法还款。",
  "loan_valuation": "估值 (单位：{token})",
  "loan_video_btn": "视频教程",
  "loan_video_title": "质押借币视频简介",
  "loan_want": "我想借款",
  "loan_warning_ltv": "追加保证金率",
  "loan_warning_ltv_tip": "如果 LTV（待还本息/质押金额）达到此阈值，系统会提醒您追加质押资产。",
  "LoanAccountID": "联系信息（确保可以联系到您）",
  "LoanAccountNumber": "输入联系电话请包含国家代码。",
  "loanAmount": "借款数量",
  "LoanAmountNew": "可借额度：{amount} {coin}（到{currentAmount}）",
  "LoanAmountNew1": "可借范围：{minAmount}-{maxAmount} {coin}",
  "LoanAmountNewPledge": "可质押额度：{amount} {coin}（从{currentAmount}<a href=\"javascript:;\" class={transferClass} id=\"transfer\">划转</a>或<a href=\"javascript:;\" class={depositClass} id=\"Deposit\">充值</a>）",
  "LoanAmountNewPledge1": "可质押范围：{minAmount}-{maxAmount} {coin}",
  "LoanEmailTips": "请输入正确的联系方式。",
  "LoanInterestRecords": "利息记录",
  "LoanInterestRecordsTips": "仅活期质押借币会提供每小时利息记录",
  "loanLualityDeposit1": "只有当前质押率小于初始质押率时，方可减少质押资产。",
  "loanLualityDeposit2": "可减少的质押数量上限是达到初始质押率的数量。",
  "loanLualityDeposit3": "若当前质押率大于等于初始质押率，则不允许减少质押资产。",
  "LoanMinAmount": "最低可申购数量：{amount}",
  "LoanMinAmountNew": "最低借款金额：",
  "LoanMinAmountTips": "申购数量需超过最低申购数量。",
  "LoanRateTips1": "活期质押借币采用小时浮动利率，按实际借款时长每小时计算利息，可提前还款。",
  "loanRecommend": "推荐",
  "loanSureTips": "在确认之前，请先勾选“我同意”复选框",
  "loanTime": "借款时间",
  "loanType": "类型",
  "login": "登录",
  "ltvAfterBorrowing": "借币后 LTV",
  "ltvExceedInitial": "借币后 LTV 不得超过初始质押率 {num1}%。",
  "ltvRatio": "质押借币数据",
  "marginCallLtvRat": "预警质押率",
  "MARKET": "市场价格",
  "max": "最大",
  "maxBorrowAmount": "借币上限",
  "maxBorrowingLimit": "最大可申请借币上限",
  "minHourlyIntRate": "最低小时利息为 0.00000001 USDT。",
  "more": "更多",
  "myLimit": "我的额度",
  "network_error": "请求失败，请稍后重试。",
  "NEW": "待成交",
  "nextPage": "下一页",
  "none": "无",
  "noRecords": "暂无记录",
  "noteSystemCalculates": "注意：系统按小时计息，不足 1 小时按 1 小时计算。",
  "OnlyDepositTransfer": "<a href=\"javascript:;\" class={transferClass} id=\"transfer\">划转</a>或<a href=\"javascript:;\" class={depositClass} id=\"Deposit\">充值</a>",
  "onlyVipCanApply": "仅 VIP 用户才可以申请。",
  "operationSuccess": "成功",
  "or": "或",
  "orderBook": "订单表",
  "orderHistory": "订单历史",
  "orderId": "订单单号",
  "orderType": "订单类型",
  "orLoan": "或",
  "otcErrorInfo": "抱歉，您开通了机构借贷，无法进行杠杆交易。",
  "otcFlexible": "活期",
  "other": "其他",
  "outstanding": "待还",
  "pauseTradeTip": "{symbol} 目前暂时无法交易。敬请参阅我们的<a href={url} target=\"_blank\">博客</a>，了解详情。",
  "pendingOrderReapply": "有申请中的订单，请稍后再次申请。  ",
  "personalizedLoanAmt": "定制额度",
  "pleaseSelect": "请选择",
  "PledgableLimitNewTips": "可质押额度：{amount} {coin} 从",
  "prevPage": "上一页",
  "price": "价格",
  "quantity": "数量",
  "reachedAccountLimit": "已达到账户限额。",
  "reachedPlatformLimit": "已达到平台限额。",
  "reachOutContactDetails": "我们将在 1 个工作日内通过您提供的联系方式与您联系。",
  "receivedApplication": "您已成功申请过，稍后可再次申请。",
  "ReduceLoan": "减少",
  "ReduceLoanAssets": "减少质押资产",
  "ReduceLoanAssetsNew": "质押资产可减金额：<span>{num} {token}</span> <a href=\"javascript:;\" class={transferClass} id=\"transfer\">划转</a>或<a href=\"javascript:;\" class={depositClass} id=\"deposit\">充值</a>",
  "ReduceLoanTip1": "不能减少质押资产，只有当前质押率小于初始质押率时才能减少质押资产。",
  "ReduceLoanTip2": "不能减少质押资产，减少的数量需小于质押资产可减数量。",
  "ReduceLoanTip3": "不能减少质押资产，减少的数量需小于质押资产可减数量，请重试。",
  "ReduceLoanTip4": "您可以在订单页面调整质押金，您可以随时添加更多质押金，若当前质押率小于初始质押率时，还可以减少质押资产。",
  "reducePledgeAssetsTransferBack": "减少质押资产将转回至",
  "remainingCollateralLimit": "剩余抵押额度",
  "remainingLimit": "剩余借币额度",
  "repayment": "还款",
  "reset": "重置",
  "resetNew": "重置",
  "result_not_found": "未找到结果",
  "reverse_contract_account": "反向合约账户",
  "reviewExpectedTime": "预计 5 分钟审核完成，届时请查看{resultLink}   ",
  "riskWarning": "确认弹窗",
  "sameLimitDontRepeat": "您当前的借币上限和本次申请的数量一致，请不要重复申请。",
  "search": "搜索",
  "searchNew": "搜索",
  "side": "方向",
  "signalStatusExpired": "已过期",
  "sns": "社交媒体平台",
  "spot_account": "现货账户",
  "state": "状态",
  "status": "状态",
  "stethTradeTipText": "在质押借币中用作质押资产的 stETH 支持每日生息。",
  "stop_limit": "止盈止损",
  "stop_limit_tips_2": "当前有止盈止损委托单，暂不支持开启杠杆交易。",
  "submitApplicationLimit": "每天最多可申请 3 次，请明天再试。",
  "submittedSuccessfully": "提交成功",
  "success": "成功",
  "successfully": "成功",
  "sure": "sure",
  "tailoredLoanTerm": "定制期限",
  "thanksForInterestVip": "感谢您对 VIP 质押借币的支持！",
  "times": "次",
  "timestamp": "时间",
  "title_404": "404 {'|'} Bybit 现货交易平台  ",
  "to": "至",
  "toastTheSymbolNotExist": "抱歉！您选择的交易对暂无法访问",
  "total": "累计",
  "totalInterest": "总利息",
  "tradeDetails": "详情",
  "tradeId": "成交号",
  "transfer": "划转",
  "uid": "您的账户 ID（确保可以联系到您）",
  "undefined": "未定义",
  "unifiedAccount": "统一交易账户",
  "usdc_contract_account": "USDC 合约账户",
  "useMainUidToApply": "请使用主 UID 申请。",
  "variableCannotBeEmpty": "{variable} 不能为空。",
  "vipCryptoLoans": "VIP 质押借币",
  "vipExclusive": "VIP 专享",
  "vipLoan": "VIP 质押借币",
  "vipLoan1": "VIP 质押借币",
  "vipLoanBorrowLimitExpire": "【Bybit】VIP质押借币借币上限到期通知\n\n您好，\n您申请的VIP借币上限已到期，如需再次申请，还请去VIP质押借币申请；\n申请币种：{coin}\n申请额度：{num} {coin}\n失效日期：{date}\n\n\nBybit 团队\n系统邮件，请勿回复.",
  "vipLoanBorrowLimitNotif": "Title\nVIP 质押借币：借币上限申请成功\n\nContent\n尊敬的用户：\n\n好消息：您提交的借币上限申请已成功，请尽快使用借币上限去借款。\n\n申请详情：\n申请币种：{'{'}{coin}{'}'}\n申请额度： {'{'}{num}{'}'} {'{'}{coin}{'}'}\n失效日期：{'{'}{date}{'}'}\n\n感谢您选择 Bybit。\n\n顺颂商祺\nBybit 团队\n\n系统邮件，请勿回复。",
  "vipLoanBorrowLimitRemind": "【Bybit】VIP质押借币借币上限到期提醒通知\n\n您好，\n您申请的VIP借币上限还剩{num}天有效期，请尽快使用借币上限去借款；\n申请币种：{coin}\n申请额度：{num} {coin}\n失效日期：{date}\n\n\nBybit 团队\n系统邮件，请勿回复.",
  "vipLowerInterestRate": "VIP 享有更优利率",
  "vipThresholdRights": "点击此处了解 VIP 门槛及专属权益。",
  "yearlyInterestRate": "年利率",
  "yearlyInterestRateNew": "年化利率"
}